export default __webpack_public_path__ + "cec6b28.png";